import List from './List';
// import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'payments',
  inputShow: gql`
    query payments($input: PaymentQueryInput) {
      payments(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  // create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Billing',
    label: 'Payments',
  },
};
